import { StudentType, UserSubscriptionPlan } from "../../constants/GlobalTypesAndEnumsAndConstants";

/**
 * Returns the user-facing display label for a subscription plan, resolving
 * Elite to per-student-type names. Never compare against the returned strings
 * for plan equality — they're for display only.
 *
 * @see UserSubscriptionPlan enum for the canonical enum-value strings used in
 * Firestore, Stripe metadata, and URL params.
 */
export function getDisplayNameForSubscriptionPlan(
  subscriptionPlan: UserSubscriptionPlan,
  studentTypeOnUserProfile: StudentType | null
): string {
  if (subscriptionPlan === UserSubscriptionPlan.SUPER_LEARNER) return "Pro";

  if (subscriptionPlan === UserSubscriptionPlan.ELITE) {
    switch (studentTypeOnUserProfile) {
      case StudentType.Medical:
      case StudentType.PreMed:
        return "Medical";
      case StudentType.Dental:
        return "Dental";
      case StudentType.Nursing:
        return "Nursing";
      case StudentType.Veterinary:
        return "Veterinary";
      case StudentType.Pharmacy:
        return "Pharmacy";
      // OtherHealthRelated and all non-health student types fall through to "Elite".
      // Per Julian's clarification: OtherHealthRelated is intentionally NOT mapped
      // to "Medical" because generic Elite branding is a better fit.
      default:
        return "Elite";
    }
  }

  if (subscriptionPlan === UserSubscriptionPlan.MEGA_MIND) return "Mega Mind";
  return "Free";
}

/**
 * Returns true if the student type has specialized health-focused Elite tier
 * branding.
 *
 * Excludes OtherHealthRelated intentionally — they get the generic "Elite"
 * label.
 */
export function isHealthStudentTypeBasedOnStudentType(
  studentTypeOnUserProfile: StudentType | null
): boolean {
  return (
    studentTypeOnUserProfile === StudentType.Medical ||
    studentTypeOnUserProfile === StudentType.PreMed ||
    studentTypeOnUserProfile === StudentType.Dental ||
    studentTypeOnUserProfile === StudentType.Nursing ||
    studentTypeOnUserProfile === StudentType.Veterinary ||
    studentTypeOnUserProfile === StudentType.Pharmacy
  );
}
